import { func, object, oneOf } from 'prop-types';

export const questionsQuickAccessPropTypes = {
  deviceType: oneOf(['mobile', 'desktop']).isRequired,
  quick_access: object.isRequired,
  onScrollComponent: func,
};
